import { IconProps } from "./Icon.model";

export function Comment01Icon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2505 2.25C18.3039 2.25 20.3309 2.25001 21.5903 3.51367C22.8498 4.77774 22.8501 6.81287 22.8501 10.8818V11.4209C22.8501 15.4898 22.8497 17.524 21.5903 18.7881C20.3309 20.0521 18.3043 20.0527 14.2505 20.0527C13.648 20.0662 13.1672 20.1119 12.6958 20.2197C11.6123 20.4702 10.5962 20.9782 9.59912 21.4766C9.41124 21.5705 9.22347 21.6644 9.03662 21.7559C7.35705 22.5778 6.51683 22.9891 5.98975 22.6045C5.48684 22.2286 5.46492 21.5196 5.60498 20.7354C5.66285 20.4114 5.69106 20.2492 5.62061 20.1475C5.55013 20.0458 5.38812 20.0159 5.06396 19.9561C4.00767 19.7609 3.1908 19.3712 2.60986 18.7881C1.3505 17.524 1.3501 15.4898 1.3501 11.4209V10.8818C1.3501 6.81287 1.35042 4.77774 2.60986 3.51367C3.86929 2.25001 5.89627 2.25 9.94971 2.25H14.2505ZM8.1001 13.25C7.68588 13.25 7.3501 13.5858 7.3501 14C7.3501 14.4142 7.68588 14.75 8.1001 14.75H16.1001C16.5143 14.75 16.8501 14.4142 16.8501 14C16.8501 13.5858 16.5143 13.25 16.1001 13.25H8.1001ZM8.1001 8.25C7.68588 8.25 7.3501 8.58579 7.3501 9C7.3501 9.41421 7.68588 9.75 8.1001 9.75H12.1001C12.5143 9.75 12.8501 9.41421 12.8501 9C12.8501 8.58579 12.5143 8.25 12.1001 8.25H8.1001Z"
        fill={fillColor}
      />
    </svg>
  );
}
